import React from 'react';
import PropTypes from 'prop-types';

export default class BigNumberGraph extends React.Component {
	static propTypes = {
		data: PropTypes.object
	};

	renderDiff(data) {
		if (data.length < 2) {
			return null;
		}

		const [cur, prev] = data;
		let percentage = ((cur - prev) / prev) * 100;

		if (percentage === Infinity) {
			percentage = 100;
		}
		if (isNaN(percentage)) {
			percentage = 0;
		}

		if (percentage > 0) {
			return <div className="text">▲ up {Math.round(percentage)}% since last month</div>;
		}

		return <div className="text negative">▼ down {Math.round(Math.abs(percentage))}% since last month</div>;
	}

	renderFields(fields) {
		if (!fields || !fields.length) {
			return null;
		}
		return (
			<div className="bignumber-fields">
				{fields.map((field) => (
					<div className="bignumber-field" key={field.title}>
						<div className="key">{field.title}</div>
						<div className="value">{field.data.toLocaleString()}</div>
					</div>
				))}
			</div>
		);
	}

	render() {
		let { data } = this.props.data;

		if (typeof data === 'number') {
			data = [data];
		}

		switch (data.length) {
		case 1:
		case 2:
			return (
				<div className="bignumbergraph-container">
					<div className="number">{data[0].toLocaleString()}</div>
					{this.renderDiff(data)}
					{this.renderFields(this.props.data.fields || [])}
				</div>
			);
		default:
			return (
				<div className="bignumbergraph-container">
					<div className="number">0</div>
				</div>
			);
		}
	}
}
